import { Box, LinearProgress } from '@mui/material';

type LoadingLinearProgressProps = {
  isLoading: boolean;
};
export const LoadingLinearProgress = (props: LoadingLinearProgressProps) => {
  const { isLoading } = props;
  return <Box sx={{ mt: 1, height: 10, alignItems: 'center', width: '100%' }}>{isLoading && <LinearProgress />}</Box>;
};
